import { Select } from "antd";
import applicationApi from "api/applicationApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import {
  ENUM_APPLICATION_STATUS,
  LIST_OPTION_APPLICATION_STATUS,
} from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const AuditionStatus = ({ data }: any) => {
  const { t, i18n } = useTranslation();

  const [currentStatus, setCurrentStatus] = useState(data?.status); // Initial state
  const [reason, setReason] = useState(data?.reason);
  const [note, setNote] = useState(data?.note);
  const [isShowReason, setIsShowReason] = useState(true);
  const [isShowNote, setIsShowNote] = useState(true);

  const LIST_OPTION_APPLICATION_STATUS_LANG = LIST_OPTION_APPLICATION_STATUS?.map((item) => {
    return {
      label: t(item?.label),
      value: item?.value
    }
  })
  const handleStatusChange = (value: any) => {
    // console.log(value);
    setCurrentStatus(value);
    // Logic to show/hide additional info based on status
    switch (value) {
      case ENUM_APPLICATION_STATUS.APPLIED:
        setIsShowReason(false);
        setIsShowNote(false);
        break;
      case ENUM_APPLICATION_STATUS.SCREENING_PASSED:
        setIsShowReason(false);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.SCREENING_FAILED:
        setIsShowReason(true);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.AUDITION_SCHEDULED:
        setIsShowReason(false);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.AUDITION_COMPLETED:
        setIsShowReason(false);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.FINAL_PASSED:
        setIsShowReason(false);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.REJECTED:
        setIsShowReason(true);
        setIsShowNote(true);
        break;
      case ENUM_APPLICATION_STATUS.USER_CANCELED:
        setIsShowReason(false);
        setIsShowNote(false);
        break;
    }
  };

  const handleReasonChange = (event: any) => {
    setReason(`${event.target.value}`);
  };

  const handleNoteChange = (event: any) => {
    setNote(`${event.target.value}`);
  };

  const handleUpdate = async () => {
    // Implement your update logic here
    // console.log("Updating status with:", {
    //   currentStatus,
    //   reason,
    //   note,
    // });

    try {
      const body = {
        status: currentStatus,
        reason: reason, // optional
        note: note, // optional
      };

      const response = await applicationApi.updateDetail(data?.id, body);
      // console.log(response);
      if (response?.statusCode == 200) {
        //reloadData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  useEffect(() => {
    if(data?.status) {
      handleStatusChange(data?.status)
    }
  }, [data])
  
  return (
    <Container fluid className="p-3">
      <Form>
        <Row className="mb-3">
          <Col md="6">
            <FormGroup row>
              <Label sm={4} for="applicationDate" className="text-muted">
                {t('Application Date')}:{" "}
              </Label>
              <div>{formatDateStringToKorea(data?.created_at)}</div>
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup row>
              <Label sm={4} for="applicationDate" className="text-muted">
                {t('Last Updated')}:{" "}
              </Label>
              <div>{formatDateStringToKorea(data?.updated_at)}</div>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup row className="mb-3 d-flex align-items-center">
          <Label sm={3} for="currentStatus">
            {t('Current Status')}
          </Label>
          <Col sm={9}>
            <Select
              className="mb-0"
              style={{ width: 200 }}
              placeholder={t("Current Status")}
              value={currentStatus}
              onChange={(value) => {
                setNote("")
                setReason("")
                handleStatusChange(value);
              }}
              options={LIST_OPTION_APPLICATION_STATUS_LANG || []}
            ></Select>
          </Col>
        </FormGroup>

        {isShowReason && (
          <FormGroup row className="mb-3">
            <Label sm={3} for="reason">
              {t('Reason')}
            </Label>
            <Col sm={9}>
              <Input
                type="textarea"
                name="reason"
                id="reason"
                value={reason}
                onChange={handleReasonChange}
              />
            </Col>
          </FormGroup>
        )}

        {isShowNote && (
          <FormGroup row className="mb-3">
            <Label sm={3} for="note">
              {t('Note')}
            </Label>
            <Col sm={9}>
              <Input
                type="textarea"
                name="note"
                id="note"
                value={note}
                onChange={handleNoteChange}
              />
            </Col>
          </FormGroup>
        )}

        <div className="text-end">
          <Button color="primary" onClick={handleUpdate}>
            {t('Button Update')}
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AuditionStatus;
